import React from 'react';
import { X } from 'lucide-react';
import { Language } from '../types';

interface VideosModalProps {
  language: Language;
  onClose: () => void;
}

const VideosModal: React.FC<VideosModalProps> = ({ language, onClose }) => {
  const videos = [
    {
      id: 'prime',
      title: language === 'en' ? 'Prime Numbers' : 'Nombres Premiers',
      description: language === 'en' 
        ? 'Learn about prime numbers and their properties through visual examples and clear explanations.'
        : 'Apprenez les nombres premiers et leurs propriétés à travers des exemples visuels et des explications claires.',
      url: language === 'fr' ? '/videos/Nombres_Premiers.mp4' : '/videos/Prime_Numbers.mp4'
    },
    {
      id: 'square',
      title: language === 'en' ? 'Square Numbers' : 'Nombres Carrés',
      description: language === 'en'
        ? 'Discover square numbers and understand how they work with interactive demonstrations.'
        : 'Découvrez les nombres carrés et comprenez leur fonctionnement avec des démonstrations interactives.',
      url: language === 'fr' ? '/videos/Nombres_Carres.mp4' : '/videos/Square_Numbers.mp4'
    }
  ];

  const handleVideoError = (e: React.SyntheticEvent<HTMLVideoElement, Event>) => {
    console.error('Error loading video:', e);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-slate-800 rounded-xl p-6 max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100">
            {language === 'en' ? 'Educational Videos' : 'Vidéos Éducatives'}
          </h2>
          <button
            onClick={onClose}
            className="text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {videos.map((video) => (
            <div 
              key={video.id}
              className="bg-slate-50 dark:bg-slate-700/50 rounded-lg overflow-hidden border border-slate-200 dark:border-slate-600"
            >
              <div className="aspect-video bg-black">
                <video
                  src={video.url}
                  controls
                  onError={handleVideoError}
                  className="w-full h-full object-cover"
                >
                  {language === 'en'
                    ? 'Your browser does not support the video tag.'
                    : 'Votre navigateur ne supporte pas la vidéo.'}
                </video>
              </div>
              <div className="p-4">
                <h3 className="text-lg font-semibold text-slate-800 dark:text-slate-100 mb-2">
                  {video.title}
                </h3>
                <p className="text-slate-600 dark:text-slate-300 text-sm">
                  {video.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VideosModal;